import { $el } from 'src/scripts/utils/utils'
import { BaseComponent } from '../../components/base-component'
import {
  getTemplateContent,
  getTemplateFirstChild,
  replaceNodeChildren,
} from '../../utils/dom'

const CONTAINER_SELECTOR = `[data-product-block-container]`

export class ProductBlock extends BaseComponent {
  updateByVariantId(variantId: number): void {
    const node = $el(CONTAINER_SELECTOR, this)
    const newNode = getTemplateContent(
      $el(`[data-product-block-template="${variantId}"]`, this),
    )

    replaceNodeChildren(node, newNode)
  }
}
